import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./RecyclingSidebar.css";

const RecyclingSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  let company = { name: "Recycling Co", username: "Recycling" };
  try {
    const stored = sessionStorage.getItem("currentUser");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.role === "recycling_company") {
        company = {
          name: parsed.companyName || parsed.username,
          username: parsed.username,
        };
      }
    }
  } catch (e) {}

  const linkClass = ({ isActive }) => (isActive ? "active" : "");

  return (
    <>
      <button 
        className="recycle-hamburger-btn" 
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle recycle sidebar"
      >
        ☰
      </button>

      {isOpen && <div className="recycle-sidebar-overlay" onClick={() => setIsOpen(false)} />}

      <div className={`recycle-sidebar ${isOpen ? "open" : ""}`}>
        <div className="recycle-top">
          <h5>{company.name}</h5>
          <div className="recycle-profile">
            <div className="recycle-avatar">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.029 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
              </svg>
            </div>
            <p className="recycle-name">{company.username}</p>
          </div>
        </div>

        <ul className="recycle-menu">
          <li>
            <NavLink to="/recycling/dashboard" className={linkClass} onClick={() => setIsOpen(false)}>
              <span className="recycle-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 4a.5.5 0 0 1 .5.5v4.793l2.146 2.147a.5.5 0 0 1-.708.708L8 9.207V4.5A.5.5 0 0 1 8 4z"/>
                  <path d="M8 0a8 8 0 1 0 8 8A8 8 0 0 0 8 0zm0 1a7 7 0 1 1-7 7 7 7 0 0 1 7-7z"/>
                </svg>
              </span> Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/recycling/detections" className={linkClass} onClick={() => setIsOpen(false)}>
              <span className="recycle-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.099zm-5.242 1.656a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"/>
                </svg>
              </span> Detections
            </NavLink>
          </li>
          <li>
            <NavLink to="/recycling/notifications" className={linkClass} onClick={() => setIsOpen(false)}>
              <span className="recycle-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>
                </svg>
              </span> Notifications
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
};

export default RecyclingSidebar;
